// eslint-disable-next-line import/prefer-default-export
export enum EDeviceCategory {
  Official = 'Official',
  Community = 'Community',
  Potential = 'Potential',
}
